import { Option, Result } from "effect";
import * as AsyncData from "foldkit/asyncData";

import { settle } from "../api/asyncData";
import { appendPage } from "./shared";

/** The badge map lives with the provenance widget (R20); re-exported for the pages. */
export { sourceBadgeClass } from "../widgets/provenance";

export const parseTags = (
	json: string | null | undefined,
): ReadonlyArray<string> => {
	try {
		const tags: unknown = JSON.parse(json || "[]");
		return Array.isArray(tags)
			? tags.filter((tag): tag is string => typeof tag === "string")
			: [];
	} catch {
		return [];
	}
};

export const versionAt = (total: number, index: number): number =>
	total - index;

type Page<T> = ReturnType<typeof appendPage<T>>;
const emptyPage = <T>(): Page<T> => ({ items: [], nextCursor: Option.none() });

/** Settles a cursor fetch, replacing page zero and appending later pages. */
export const settlePage = <T, E>(
	state: AsyncData.AsyncData<Page<T>, E>,
	cursor: number,
	result: Result.Result<Parameters<typeof appendPage<T>>[2], E>,
): AsyncData.AsyncData<Page<T>, E> => {
	const current = AsyncData.getOrElse(state, emptyPage<T>);
	return settle(
		state,
		Result.map(result, (page) => appendPage(current, cursor, page)),
	);
};

export const nextCursor = <T, E>(
	state: AsyncData.AsyncData<Page<T>, E>,
): Option.Option<number> => AsyncData.getOrElse(state, emptyPage<T>).nextCursor;
